const permissionsInfo = {
  calls: {
    create: ['calls:create'],
    delete: ['calls:delete'],
    edit: ['calls:edit'],
    view: ['calls:view']
  },
  dashboard: {
    view: ['dashboards:view']
  },
  doctors: {
    create: ['doctors:create'],
    delete: ['doctors:delete'],
    edit: ['doctors:edit'],
    view: ['doctors:list:view']
  },
  tenants: {
    freeze: ['tenants:freeze'],
    create: ['tenants:create'],
    view: ['tenants:view'],
    edit: ['tenants:edit'],
    list: {
      users: ['tenants:users:view'],
      groups: ['tenants:groups:view']
    },
    manage: {
      groups: ['tenants:users:group:manage']
    }
  },
  tenants_config: {
    users: {
      create: ['tenants_config:users:create'],
      view: ['tenants_config:users:view']
    },
    list: {
      users: ['tenants_config:users:list:view']
    }
  },
  users: {
    delete: ['users:delete'],
    create: ['users:create'],
    view: ['users:list:view'],
    profile: {
      edit: ['users:profile:edit']
    },
    manage: {
      tenants: ['users:tenant:manage'],
      groups: ['users:group:manage']
    },
    lock: {
      all: ['users:lock'],
      tenant: ['users:tenant:lock']
    }
  },
  groups: {
    delete: ['groups:delete'],
    create: ['groups:create'],
    view: ['groups:view'],
    edit: ['groups:edit'],
    list: {
      users: ['groups:view'],
      tenants: ['groups:tenant:manage']
    }
  },
  patients: {
    delete: ['patients:delete'],
    create: ['patients:create'],
    view: ['patients:view'],
    edit: ['patients:edit'],
    list: {
      view: ['patients:list:view']
    },
    processes: {
      view: ['patients:processes:list:view']
    }
  },
  operatories: {
    view: ['operatories:list:view'],
    overview: ['operatories:overview:view'],
    create: ['operatories:create'],
    edit: ['operatories:edit'],
    delete: ['operatories:delete']
  },
  treatments: {
    view: ['treatments:list:view'],
    create: ['treatments:create'],
    edit: ['treatments:edit'],
    delete: ['treatments:delete']
  },
  processes: {
    view: ['processes:list:view'],
    start: ['processes:start'],
    terminate: ['processes:terminate:init'],
    reschedule_cancel: ['processes:reschedule_cancel:init'],
    early_arrival: ['processes:early_arrival:init']
  },
  tasks: {
    view: ['tasks:list:view'],
    personal: {
      view: ['tasks:personal:view']
    },
    group: {
      view: ['tasks:group:view']
    },
    claim: ['tasks:claim'],
    complete: ['tasks:complete'],
    time: {
      target: ['tasks:time:target:manage']
    }
  },
  surveys: {
    list: {
      view: ['surveys:list:view']
    },
    view: ['surveys:view'],
    create: ['surveys:create'],
    delete: ['surveys:delete'],
    complete: ['surveys:complete']
  },
  settings: {
    process_progress_alert_range: {
      manage: ['settings:process_progress_alert_range:manage']
    },
    task_progress_alert_range: {
      manage: ['settings:task_progress_alert_range:manage']
    }
  }
};

export default permissionsInfo;
